import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import NotificationModal from '../components/NotificationModal';

function NotificationsPage() {
  const token = localStorage.getItem('token');
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState('all');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalPayload, setModalPayload] = useState({});

  const fetchNotes = useCallback(async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/api/users/notifications`, { headers: { Authorization: `Bearer ${token}` } });
      setNotifications(res.data || []);
    } catch (err) {
      // ignore
    }
  }, [token]);

  useEffect(() => { fetchNotes(); }, [fetchNotes]);

  const filtered = notifications.filter(n => {
    if (filter === 'all') return true;
    if (filter === 'unread') return !n.read;
    return n.type === filter;
  });

  const openNote = async (n) => {
    try {
      await axios.patch(`${process.env.REACT_APP_API}/api/users/notifications/${n._id}/read`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setNotifications(prev => prev.map(x => x._id === n._id ? { ...x, read: true } : x));
    } catch (err) {}
    setModalPayload({ 
      title: n.title || n.message, 
      body: n.body || n.message, 
      from: (n.type === 'admin_message' ? "Chiqui's Garden" : (n.meta && n.meta.from) || ''),
      meta: n.meta || null
    });
    setModalOpen(true);
  };

  const markAllRead = async () => {
    try {
      // PATCH each unread notification as read
      const unread = notifications.filter(n => !n.read);
      await Promise.all(unread.map(n => axios.patch(`${process.env.REACT_APP_API}/api/users/notifications/${n._id}/read`, {}, { headers: { Authorization: `Bearer ${token}` } })));
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
    } catch (err) {}
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Notifications</h2>
      <div style={{ marginBottom: 12 }}>
        <select value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">All</option>
          <option value="unread">Unread</option>
          <option value="points">Points</option>
          <option value="admin_message">Admin Messages</option>
        </select>
  <button style={{ marginLeft: 12 }} onClick={markAllRead}>Mark all read</button>
  <button style={{ marginLeft: 12 }} onClick={fetchNotes}>Refresh</button>
      </div>

      <div>
        {filtered.length === 0 ? (
          <div>No notifications</div>
        ) : (
          filtered.map(n => (
            <div key={n._id} style={{ padding: 10, borderBottom: '1px solid #eee', background: n.read ? '#fff' : '#f9f9ff', cursor: 'pointer' }} onClick={() => openNote(n)}>
              <div style={{ fontWeight: 600 }}>{n.title || n.message}</div>
              <div style={{ fontSize: 12, color: '#666' }}>{new Date(n.createdAt).toLocaleString()}</div>
              <div style={{ marginTop: 6 }}>{n.type}</div>
            </div>
          ))
        )}
      </div>

      <NotificationModal open={modalOpen} onClose={() => setModalOpen(false)} title={modalPayload.title} body={modalPayload.body} from={modalPayload.from} meta={modalPayload.meta} />
    </div>
  );
}

export default NotificationsPage;
